import useSWR from 'swr';

import { getUserSignups } from '@/api/signups';
import { ENDPOINTS } from '@/api/endpoints';
import { isDevEnv } from '@/libs/dev-logs';

type GetUserSignupsResponse = Awaited<ReturnType<typeof getUserSignups>>;

export const useGetUserSignups = (onlyNew = false) => {
  const { data, error, isLoading, mutate } = useSWR<GetUserSignupsResponse, Error>(
    [ENDPOINTS.SIGNUPS, onlyNew],
    ([, onlyNewParam]) => getUserSignups(onlyNewParam as boolean),
    { errorRetryCount: 1, revalidateOnFocus: !isDevEnv() }
  );

  return {
    error,
    signups: data ?? [],
    loading: isLoading,
    refetch: mutate,
  };
};
